var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NumericInput',{attrs:{"readonly":"","hide-description":"","value":_vm.total}},[_vm._t("label",null,{"slot":"label"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }